<template>
  <div style="height: inherit; padding-top: 10px; font-family: 黑体">
    <!--<el-form :label-position="labelPosition" style="font-size: 32px; margin-left: 30px; background-color: purple;" inline class="demo-table-expand">-->
      <el-row >
        <el-col :span="6" offset="3" >
          <div class="numBox">
            <span class="numBox_Title" >设备总数：</span><br>
            <span class="numBox_Num">{{devNum}}</span>
            <span class="numBox_Unit">台</span>
          </div>
        </el-col>
        <el-col :span="6" >
          <div class="numBox">
            <span class="numBox_Title" >未巡检：</span><br>
            <span class="numBox_Num">{{nonInspectNum}}</span>
            <span class="numBox_Unit">台</span>
          </div>
        </el-col>
        <el-col :span="6" >
          <div class="numBox">
            <span class="numBox_Title" >待维修：</span><br>
            <span class="numBox_Num">{{toRepairNum}}</span>
            <span class="numBox_Unit">台</span>
          </div>
        </el-col>

      </el-row>
    <!--</el-form>-->

  </div>
</template>

<script>
export default {
  name: 'HomeHeader',
  props: ['areaId','areaName'],
  data(){
    return {
      devNum:0, // 全市设备总数
      toRepairNum: 0, // 待维修设备数

      // 巡检情况（区）
      AreaInspectSta:{
        "version": 1,
        "method": "synthScreen.AreaInspectSta",
        "params": {
          "areaId":"",
        },
        "token": "#",
        "id": 0
      },

      // 巡检情况（市）
      GlobalInspectSta:{
        "version": 1,
        "method": "synthScreen.GlobalInspectSta",
        "params": {
          "areaId": "0",
        },
        "token": "#",
        "id": 0
      },
      // 地图上方大字
      DevSta:{
        "version": 1,
        "method": "synthScreen.DevSta",
        "params": {
          "areaId":"0",
        },
        "token": "#",
        "id": 0
      },
      labelPosition: "left",
      inspectNum:0, // 已巡检数量
      nonInspectNum:0, // 未巡检数量
    }
  },
  methods:{
    // getGlobalInspectSta(){
    //   this.GlobalInspectSta.token = this.$store.state.token;
    //   console.log('获取巡检情况');
    //   console.log(this.GlobalInspectSta);
    //   this.$axios.post(this.$newMainUrl, this.GlobalInspectSta).then(res=> {
    //     console.log('获取巡检情况请求得到响应');
    //     console.log(res.data);
    //     if(res.data.hasOwnProperty('result')){
    //       this.inspectNum = res.data.result.inspectNum;
    //       this.nonInspectNum = res.data.result.nonInspectNum;
    //     }else{
    //       this.$message({
    //         type:'error',
    //         message:'获取警报点静态信息失败，' + res.data.error.message
    //       })
    //     }
    //   })
    // },
    // getAreaInspectSta(){
    //   this.AreaInspectSta.token = this.$store.state.token;
    //   this.AreaInspectSta.params.areaId = this.areaId;
    //   console.log('获取巡检情况');
    //   console.log(this.AreaInspectSta);
    //   this.$axios.post(this.$newMainUrl, this.AreaInspectSta).then(res=> {
    //     console.log('获取巡检情况请求得到响应');
    //     console.log(res.data);
    //     if(res.data.hasOwnProperty('result')){
    //       this.inspectNum = res.data.result.inspectNum;
    //       this.nonInspectNum = res.data.result.nonInspectNum;
    //     }else{
    //       this.$message({
    //         type:'error',
    //         message:'获取警报点静态信息失败，' + res.data.error.message
    //       })
    //     }
    //   })
    // },
    getDevSta(){
      this.DevSta.token = this.$store.state.token;
      this.DevSta.params.areaId = this.areaId;
      console.log('获取地图上方数据');
      console.log(this.DevSta);
      this.$axios.post(this.$newMainUrl, this.DevSta).then(res=> {
        console.log('获取地图上方数据请求得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          this.devNum = res.data.result.operNum[this.areaId]["devNum"];
          this.toRepairNum = res.data.result.operNum[this.areaId]["toRepairNum"];
          this.nonInspectNum = res.data.result.operNum[this.areaId]["nonInspectNum"];
          this.inspectNum = res.data.result.operNum[this.areaId]["inspectNum"];
        }else{
          this.$message({
            type:'error',
            message:'获取警报点静态信息失败，' + res.data.error.message
          })
        }
      })
    },

    switchMap(){
      // console.log('switchMap');
      // this.realMapShow =  !this.realMapShow;
      // this.real =  true;
      // this.$emit('feedBack', this.realMapShow);

      this.$router.push('/map');
    },
    getSystemStatistics(){
      this.GetSystemStatistics.token = this.$store.state.token;
      for(let key in this.GetSystemStatistics.params){
        if(this.GetSystemStatistics.params[key] === ""){
          this.GetSystemStatistics.params[key] = null;
        }
      }
      console.log('获取表格数据请求');
      console.log(this.GetSystemStatistics);
      this.$axios.post(this.$newMainUrl, this.GetSystemStatistics).then(res=>{
        console.log('获取表格数据请求得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          this.$message({
            type:'success',
            message:'获取表格数据成功'
          })
          this.SystemStatistics = res.data;
          this.drawAll();
        }else{
          this.$message({
            type:'error',
            message:'获取表格数据失败，' + res.data.error.message
          })
        }
      }).catch(error=>{
        this.$message({
          type:'error',
          message:error
        })
      })
    },

  },
  watch:{
    areaId(newValue, oldValue){
      // if(this.areaName === "南京市"){
      //   this.getDevSta();
      // }else{
      //   this.getAreaInspectSta();
      // }
        this.getDevSta();

    }
  },
  mounted () {
    // if(this.areaName === "南京市"){
    //   //this.getGlobalInspectSta();
    //   this.getDevSta()
    // }else{
    //   this.getAreaInspectSta();
    // }
    this.getDevSta();
    // this.getSystemStatistics();

  },
}
</script>

<style scoped>
  .numBox{
    width: 110px; height: 60px; background-color: #142664; color: white; text-align: center;
  }
  .numBox_Title{
    font-size: 16px;
  }
  .numBox_Num{
    font-size: 32px; color: #00fea8; text-decoration:underline #00fea8
  }
  .numBox_Unit{
    font-size: 16px; color: white; margin-left: 5px;
  }

</style>
<style>
  .topBlock{
    display: flex; flex-wrap: nowrap;
  }
  .demo-table-expand {
    font-size: 0;
  }
  .topBlock span{
    display: inline-block;
    width: 90px;
    color: #99a9bf;
    margin-top: 3px;
    margin-right: -30px;
  }
  .el-col:nth-child(1) .topBlock{
    /*margin-left: 50px;*/
    /*background-color: yellow;*/
  }
  .el-col .topBlock{
    /*margin-left: 50px;*/
    /*background-color: yellow;*/
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>

